import Picklists from '../../../store/picklists';

angular
    .module('festzelt-os.picklists')
    .factory('Picklists', [
        '$injector',
        'Picklist',
        ($injector, Picklist) => new Picklists(Picklist, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/picklists/store/picklists.js